export const safeUrl = (url, fallback = "#") => {
  if (!url || typeof url !== "string") return fallback;

  const trimmed = url.trim();

  if (trimmed.startsWith("/")) return trimmed;

  try {
    const parsed = new URL(trimmed);
    const allowedProtocols = ["https:", "http:", "mailto:", "tel:"];

    if (allowedProtocols.includes(parsed.protocol)) {
      return trimmed;
    }

    return fallback;
  } catch {
    return fallback;
  }
};

export const safeEmbedUrl = (url) => {
  if (!url || typeof url !== "string") return null;

  try {
    const parsed = new URL(url.trim());
    const hostname = parsed.hostname.replace("www.", "");

    if (hostname === "youtube.com" || hostname === "youtu.be") {
      const id =
        hostname === "youtu.be"
          ? parsed.pathname.replace("/", "")
          : parsed.searchParams.get("v");

      if (!id) return null;
      return `https://www.youtube.com/embed/${id}`;
    }

    if (hostname === "vimeo.com") {
      const id = parsed.pathname.replace("/", "");
      if (!id) return null;
      return `https://player.vimeo.com/video/${id}`;
    }

    return null;
  } catch {
    return null;
  }
};